<div class="flex-col ta-c mx-2">
    <div class="mat-display-3 mt-4 mb-2">Jevans' Space</div>

    <div class="shrug mb-2 px-2">
        <img src="assets/images/jevans-shrug-transparent.png" alt="Shrug emoticon">
    </div>

    <div class="mat-title mb-4">You can click this button to view some of my projects</div>

    <div>
        <a mat-flat-button color="primary" href="/projects">
            View Projects
        </a>
    </div>

    <div class="mat-title my-4">You can click this button to download my CV</div>

    <div>
        <a mat-flat-button color="primary" href="assets/documents/jack-evans-cv.pdf" target="_blank">
            Download CV
        </a>
    </div>

    <div class="mat-title my-4">You can find me on any of these platforms</div>

    <div class="platforms">
        <a href="https://twitter.com/Jevans_Games" target="_blank" matTooltip="Twitter">
            <img src="assets/images/logos/twitter-logo.png" alt="Twitter logo">
        </a>

        <a href="https://www.linkedin.com/in/jack-evans-7b6130bb/" target="_blank" matTooltip="LinkedIn">
            <img src="assets/images/logos/linkedin-logo.png" alt="LinkedIn logo">
        </a>

        <a href="https://github.com/JackEvans24/" target="_blank" matTooltip="GitHub">
            <img src="assets/images/logos/github-logo.png" alt="GitHub logo">
        </a>

        <a href="https://jevansmassive.itch.io/" target="_blank" matTooltip="itch.io">
            <img src="assets/images/logos/itch-logo.png" alt="itch.io logo">
        </a>

        <a href="https://www.redbubble.com/people/Jevansmassive/explore/" target="_blank" matTooltip="Redbubble">
            <img src="assets/images/logos/redbubble-logo.png" alt="Redbubble logo">
        </a>

        <a href="https://open.spotify.com/user/kizbjf08z7d5hz40z4fugw2qw" target="_blank" matTooltip="Spotify">
            <img src="assets/images/logos/spotify-logo.png" alt="Spotify logo">
        </a>

        <a href="https://letterboxd.com/Jevansmassive/" target="_blank" matTooltip="Letterboxd">
            <img src="assets/images/logos/letterboxd-logo.svg" alt="Letterboxd logo">
        </a>

        <a href="https://steamcommunity.com/id/jevansmassive/" target="_blank" matTooltip="Steam">
            <img src="assets/images/logos/steam-logo.png" alt="Steam logo">
        </a>

    </div>
</div>
